var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2324 10.5635C36.0591 10.5635 14.0054 32.6172 14.0054 59.7905C14.0054 86.9638 36.0591 109.017 63.2324 109.017C90.4056 109.017 112.459 86.9638 112.459 59.7905C112.459 32.6172 90.4549 10.5635 63.2324 10.5635ZM78.0004 70.7681L63.7246 78.989C61.9524 80.0228 59.9834 80.5151 58.0635 80.5151C56.0944 80.5151 54.1746 80.0228 52.4024 78.989C48.8581 76.9215 46.7413 73.2787 46.7413 69.1436V52.6526C46.7413 48.5668 48.8581 44.8747 52.4024 42.8072C55.9468 40.7397 60.1803 40.7397 63.7738 42.8072L78.0497 51.0281C81.594 53.0956 83.7108 56.7384 83.7108 60.8735C83.7108 65.0086 81.594 68.7006 78.0004 70.7681Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_492",
    x: 0.307617,
    y: 0.71814,
    width: 126.145,
    height: 126.145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e56d71484e01470e98a3bcace3ae7f9c.svg";
export { ForwardRef as ReactComponent };